<template>


</template>

<script>

    export default {
        name: "design-2021-magazine-lock-message-component",
        props: ['message'],
        mounted: function(){
            if(this.message && this.message.length)
            {
                this.alert.notice(this.$t('magazine.in_use'), this.message);
            }
        }
    }
</script>

<style scoped>

</style>